import { render, staticRenderFns } from "./ed-response-course-material-object.vue?vue&type=template&id=b044aa24&"
import script from "./ed-response-course-material-object.ts?vue&type=script&lang=ts&"
export * from "./ed-response-course-material-object.ts?vue&type=script&lang=ts&"
import style0 from "./ed-response-course-material-object.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports